import React, { useState, useEffect, useContext, useCallback } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import Select from "react-select";
import { Link, NavLink, useParams } from "react-router-dom";

const ItemList = ({ customStyles }) => {
  const { apiURL, apiHeaderJson, apiHeaderFile, user_profile_id } =
    useContext(ConfigContext);
  const [rows, setRows] = useState([]);
  const [ItemRows, setItemRows] = useState([]);
  const [next, setNext] = useState(false);
  const [prev, setPrev] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loadingList, setLoadingList] = useState(true);
  const [keyword, setKeyword] = useState("");
  const [reload, setReload] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [selectOption, setSelectOption] = useState(null);
  const [status, setStatus] = useState(null);
  const [itemRemark, setItemRemark] = useState("");
  const [comment, setComment] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    consultant: "",
    project: "",
    contractor: "",
    submittalType: "",
    description: "",
    submittedBy: { name: "", position: "" },
    consultantRevision: "",
    attachments: [],
    approvalStatus: "",
    refNumber: "",
    title: "",
    revisionNumber: "",
    date: "",
    approvals: { name: "", position: "", date: "" },
    clearances: {
      electrical: false,
      architecture: false,
      civil: false,
      mechanical: false,
      digitalSignature: false,
      comments: ""
    },
  });

  const revisionStatusOptions = [
    "Approved",
    "Approved with comments",
    "Rejected"
  ];

  const { project_id } = useParams();

  const options = [
    { value: "pending", label: "Pending" },
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
  ];

  const AcceptRejectRequest = (actionType) => {
    Swal.fire({
      title: `Submit Remark for ${actionType}`,
      input: "text",
      inputPlaceholder: "Enter your Remark",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) {
          return "Remark cannot be empty";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Show success message
        Swal.fire({
          icon: "success",
          title: "Remark successfully submitted",
          showConfirmButton: false,
          timer: 1500, // Auto-close after 1.5 seconds
        }).then(() => {
          // Update state based on action
          if (actionType === "Accept") {
            setStatus("approved");
          } else if (actionType === "Cancel") {
            setStatus("rejected");
          }
        });
      }
    });
  };

  const handleApprove = () => {
    Swal.fire({
      icon: "success",
      title: "Request Approved Successfully",
      showConfirmButton: false,
      timer: 1500,
    });

    // Update status to approved
    setStatus("approved");
  };

  useEffect(() => {
    GetList();
  }, [page]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "itemRemark") {
      setItemRemark(value);

    }
    else if (name === "comment") {
      setComment(value)
    }
    else if (name === "keyword") {
      setKeyword(value);
    }
  };

  const handleFilter = () => {
    setPage(1);
    setReload(true);
  };

  const GetList = async () => {
    try {
      const headers = apiHeaderJson;
      const response = await axios.get(
        `${apiURL}api/consultants/Get-Request-Items`,
        {
          params: { pi_project_id: project_id },
          headers,
        }
      );
      const data = response.data;
      console.log(response.data,"all request items")
      if (data.success) {
        setRows(data.data);
        setNext(data.next);
        setPrev(data.prev);
        setPage(data.page);
        setTotalRecords(data.total_records);
        setTotalPages(data.total_pages);
        setReload(false);
      }
      setLoadingList(false);
    } catch (error) {
      console.log(error);
    }
  };



  const handlePrev = () => {
    if (prev) {
      setPage((prevPage) => prevPage - 1);
    }
  };

  const handleNext = () => {
    if (next) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const handleChange = (e) => {
    setPage(parseInt(e.target.value, 10));
  };

  const resetForm = () => {
    setItemRows("");
  };

  const handleClear = () => {
    setKeyword("");
    setReload(true);
  };

  // Handler for when the user selects options

  // const handleSelect = (selectedOption) => {
  //     setItemId(selectedOption ? selectedOption.value : null);
  //     setSelectedOptions(selectedOption);
  // };
  const Labels = (status) => {
    if (status === 0) {
      return "Pending";
    } else if (status === 1) {
      return "Approved";
    } 
    else if (status === 2) {
      return "Rejected";
    }
    else if (status === 3) {
      return "Revise";
    }
  };
  const Classes = (status) => {
    if (status === 0) {
      return "badge bg-warning-subtle text-warning";
    } else if (status === 1) {
      return "badge bg-success-subtle text-success";
    }
     else if (status === 2) {
      return "badge bg-danger-subtle text-danger";
    }
     else if (status === 3) {
      return "badge bg-info-subtle text-info";
    }
  };

  const handleSelectStatus = (selectedOption) => {
    setSelectOption(selectedOption ? selectedOption.value : "");
  };
  const ClearModal = () => {
    setComment('')
  }
  const typeText = (type) => {
    if (type === 1) {
      return 'Approve'
    }
    if (type === 2) {
      return "Revise and Resubmit"
    }
    if (type === 3) {
      return "Reject"
    }
  }
  const ConsultantStatus = () => {

  }

  const SubmitModal = async (type) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: typeText(type)
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Success",
            text: `Request ${typeText(type)}`,
            icon: "success"
          });
          document.getElementById("close-create-modal")?.click();
        }
      });

      const headers = apiHeaderJson;
      const response = await axios.post(`${apiURL}`, { params: { comment: comment, type } })
      const { success } = response.data;


    } catch (error) {
      console.log(error);

    }
  }

  useEffect(() => {
    // getItemsList();
    reload && GetList();
  }, [reload]);

  return (
    <div className="main-content">
      <div className="page-content">
        {loadingList === false ? (
          <div className="container-fluid">
            <br />
            <PageTitle title={`Requested Items`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div
                    className="card-header align-items-center d-flex"
                    style={{
                      background: "#000000",
                    }}
                  >
                    <h4 className="card-title mb-0 flex-grow-1 text-white">Requested List</h4>
                    <div className="col-md-3 mx-3 mb-3">
                      <div className="row">
                        <div className="col-md-5"></div>
                      </div>
                    </div>
                    <div className="avatar-xs flex-shrink-0 ms-auto">
                      <NavLink
                        to={"/ProjectList"}
                        className="avatar-title bg-white rounded-circle fs-4"
                        style={{
                          color: "#184c8f",
                        }}
                      >
                        <i className="las la-list"></i>
                      </NavLink>
                    </div>
                  </div>

                  <div
                    className="card-header pt-0 pb-0"
                    style={{ border: "none" }}
                  >
                    <div className="row pb-2  py-4 mb-3">
                      <div className="col-md-4">
                        <Select
                          options={options} // Pass the options array
                          value={
                            selectOption
                              ? options.find(
                                (option) => option.value === selectOption
                              )
                              : null
                          }
                          onChange={handleSelectStatus}
                          styles={customStyles}
                          placeholder="Please Select Status"
                        />
                      </div>
                      <div className="col-md-4"></div>

                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-5"></div>
                          <div className="col-md-7">
                            <div className="dropdown">
                              <button
                                type="button"
                                className="btn btn-light btn-label waves-effect waves-light "
                                id="dropdownMenuLink4"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i className="ri-download-2-line label-icon align-middle fs-16 me-2" />
                                Download Report
                              </button>
                              <ul
                                className="dropdown-menu dropdown-menu-end"
                                aria-labelledby="dropdownMenuLink4"
                              >
                                <li>
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    <i className="ri-printer-line me-2 align-middle text-muted" />
                                    Print
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    <i className="ri-file-pdf-line me-2 align-middle text-muted" />
                                    PDF
                                  </a>
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      href="javascript:void(0);"
                                    >
                                      <i className="ri-file-excel-2-line me-2 align-middle text-muted" />
                                      Excel
                                    </a>
                                  </li>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="card-body pt-0">
                      <table className={`table table-bordered table-stripped `}>
                        <thead className="table-light">
                          <tr>
                            <th className="text-center" width="28%">
                              Item Name
                            </th>
                            <th className="text-center" width="18%">
                              Quantity
                            </th>
                            <th className="text-center" width="18%">
                              Price(QAR)
                            </th>
                            <th className="text-center" width="15%">
                              Status
                            </th>
                            <th className="text-center" width="15%">
                              Action
                            </th>
                          </tr>
                        </thead>
                        {rows.length !== 0 ? (
                          <tbody>
                            {project_id &&
                              rows.map((row) => (
                                <tr key={row.category_id}>
                                  <td className="text-center">
                                    {row?.pi_item_title ?? "-"}
                                  </td>
                                  <td className="text-center">
                                    {row?.pi_item_qty}
                                  </td>
                                  <td className="text-center">
                                    {row?.pi_item_price}
                                  </td>
                                  <td className="text-center">
                                    <span className={Classes(row.pi_status)}>
                                      {Labels(row.pi_status)}
                                    </span>
                                  </td>
                                  {/* <td className="text-center">Architecture</td> */}

                                  {/* <td className="d-flex justify-content-around">
                                    Reject Button
                                    {row.pi_status === 0 && (
                                      <button
                                        onClick={() =>
                                          AcceptRejectRequest("Cancel")
                                        }
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm btn-icon waves-effect waves-light"
                                      >
                                        <i className="  ri-close-line align-middle fs-15 "></i>
                                      </button>
                                    )}
                                  </td> */}
                                  <td className="d-flex justify-content-around">
                                    <button
                                      type="button"
                                      className="btn btn-link text-success fs-18 p-0"
                                      data-bs-toggle="modal"
                                      data-bs-target="#myModal"
                                    >
                                      <i className="  ri-checkbox-multiple-line" />
                                    </button>
                                    <Link to={`/PreviewStatus`}>
                                      <button
                                        type="button"
                                        className="btn btn-link text-info fs-18 p-0"

                                      >
                                        <i className=" ri-eye-line" />
                                      </button>
                                    </Link>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        ) : (
                          <tbody>
                            <tr>
                              <td colSpan="8">
                                <NoRecords />
                              </td>
                            </tr>
                          </tbody>
                        )}
                        <tfoot className="table-light">
                          <tr>
                            <th colSpan={6}>
                              <div className="d-flex justify-content-between">
                                <button
                                  disabled={
                                    prev === false && loadingList === false
                                      ? true
                                      : false
                                  }
                                  type="button"
                                  onClick={() => handlePrev()}
                                  className={`btn btn-warning btn-label waves-effect waves-light`}
                                >
                                  <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                  Previous
                                </button>
                                <div
                                  className="col-md-4"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {
                                    <small>
                                      Total Records: {totalRecords} | Total
                                      Pages: {totalPages} | Current Page: {page}
                                    </small>
                                  }
                                </div>
                                <div className="col-md-2">
                                  <select
                                    className="form-select"
                                    onChange={(e) => handleChange(e)}
                                  >
                                    {Array.from(
                                      { length: totalPages },
                                      (_, i) => (
                                        <option
                                          key={i + 1}
                                          selected={page === i + 1}
                                          value={i + 1}
                                        >
                                          {i + 1}
                                        </option>
                                      )
                                    )}
                                  </select>
                                </div>
                                <button
                                  disabled={
                                    next === false && loadingList === false
                                      ? true
                                      : false
                                  }
                                  type="button"
                                  onClick={() => handleNext()}
                                  className={`btn btn-primary btn-label waves-effect right waves-light`}
                                >
                                  <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                                  Next
                                </button>
                              </div>
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <ContentLoader />
        )}
      </div>
      <>
        <div
          id="myModal"
          className="modal fade"
          tabIndex={-1}
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          style={{ display: "none" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              {/* Modal Header */}
              <div
                className="modal-header d-flex justify-content-between align-items-center"
                style={{ background: "#000000", padding: "15px" }}
              >
                <div className="w-100">
                  <div className="row">
                    <div className="col-md-4">
                      <h5 className="mb-0 text-white">Title: Canyon Ridge</h5>
                    </div>
                    <div className="col-md-4">
                      <h5 className="mb-0 text-white">Ref.#: 000000</h5>
                    </div>
                    <div className="col-md-4">
                      <h5 className="mb-0 text-white">Rev # : 00</h5>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => ClearModal()}
                  id="close-create-modal"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  style={{ filter: "invert(1)" }} // Keeps close button visible
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                {/* Item Details */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label>Item Name</label>
                    <input type="text" className="form-control" value="Cement" readOnly />
                  </div>
                  {/* <div className="col-md-4">
                    <label>Quantity</label>
                    <input type="number" className="form-control" value="100" readOnly />
                  </div>
                  <div className="col-md-4">
                    <label>Price</label>
                    <input type="text" className="form-control" value="4000" readOnly />
                  </div>
                 */}
                </div>

                {/* Material and Date */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label>Type Of Submittal</label>
                    <input
                      type="text"
                      className="form-control"
                      value="Material and Product Data"
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label>Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value="2025-03-21"
                      readOnly
                    />
                  </div>
                </div>

                {/* File Section */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label>Uploaded Files</label>
                    <div className="p-2 border rounded bg-light ">
                      <span className="text-primary fw-bold">dummy-file.pdf</span>
                    </div>
                  </div>
                </div>

                {/* Requirement Section */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label>Breif Description</label>
                    <textarea
                      className="form-control"
                      value="For strong and durable construction, high-quality cement is essential to ensure better bonding, crack resistance, and long-term structural stability. It should have good compressive strength, quick setting time, and resistance to environmental factors like moisture and heat."
                      readOnly
                      rows={3}
                    />
                  </div>
                </div>

                {/* Consultant Revision */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label>Consultant Revision</label>
                    <textarea
                      className="form-control"
                      value={comment}
                      name="comment"
                      placeholder="Please enter the comment"
                      onChange={(e) => handleInputChange(e, "consultantRevision")}
                      rows={6}
                      cols={50}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="col-md-12">
                      <div className="d-flex flex-column gap-2 " style={{ marginTop: "30px" }}>
                        <button type="button" onClick={() => SubmitModal(1)} className="btn btn-success waves-effect waves-light w-75">
                          Approve
                        </button>
                        <button type="button" onClick={() => SubmitModal(2)} className="btn btn-info waves-effect waves-light w-75">
                          Revise & Resubmit
                        </button>
                        <button type="button" onClick={() => SubmitModal(3)} className="btn btn-danger waves-effect waves-light w-75">
                          Reject
                        </button>
                      </div>
                    </div>
                  </div>


                </div>
              </div>


            </div>
          </div>
        </div>


        {/* /.modal */}
      </>

    </div>
  );
};

export default ItemList;
